import {req} from './requestHelper';
import jwt from 'jsonwebtoken';
import {TOKEN_KEY, SystemKey, IdentityTypes} from '../constants';

const defaultAuthInfo = {claims: [], userId: '', email : '', name : '', identityType: ''};
///根據身分型態計算權限
function calculateClaims(identityType = IdentityTypes.None, originalClaims = []){
    // 管理者保持不變
    if(originalClaims.some(c => c === 'admin' || c === 'super')){
        return originalClaims;
    }
    switch (identityType){
        case IdentityTypes.Student:
            return originalClaims;
        case IdentityTypes.Teacher:
            return ['teacher'];
        default:
            return [];
    }
}
export async function login(cred) {
    try {
        const res = await req('/api/login', {
            method: 'post',
            data: {...cred, systemKey : SystemKey}
        });
        const {success, token} = res.data;
        setAuth(success ? token : undefined);
    } catch (e) {
        setAuth(undefined);
    }
    return getAuth();
}

export function logout() {
    clearAuth();
}

export const getAuth = () => {
    const token = getAuthToken();
    if (token) {
        const {claims = [], userId = '', email = '', name= '', identityType = ''} = jwt.decode(token);
        //過期
        if (isTokenExpired(token)) {
            clearAuth();
            return defaultAuthInfo;
        }
        return {claims: calculateClaims(identityType, claims), userId, email, name, identityType}
    }
    return defaultAuthInfo;
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const clearAuth = () => {
    if(getAuthToken()){
        localStorage.removeItem(TOKEN_KEY);
    }
};

export const setAuth = token => {
    localStorage.removeItem(TOKEN_KEY);
    if (token) {
        localStorage.setItem(TOKEN_KEY, token);
    }
};

const isTokenExpired = token => {
    const {exp} = jwt.decode(token);
    const currentTime = Date.now().valueOf() / 1000;
    return !exp || exp < currentTime;
};